import { Heading, IconButton } from '@components'
import type { Setup } from '@here/api'
import { A } from '@solidjs/router'
import { ArrowLeft } from 'lucide-solid'
import { type ParentComponent, Show } from 'solid-js'
import { Box, Flex } from 'styled-system/jsx'
import Actions from './Actions'
import Menu from './Menu'
import { Navigation } from './Navigation'

interface HeaderProps {
	setup: Setup
}

const Header: ParentComponent<HeaderProps> = (props) => {
	return (
		<Flex
			align="center"
			justify="space-between"
			gap={4}
		>
			<Flex
				align="center"
				gap={2}
			>
				<A href="/setups">
					<IconButton
						size="xs"
						variant="outline"
					>
						<ArrowLeft size={24} />
					</IconButton>
				</A>

				<Box display={{ base: 'none', mdDown: 'block' }}>
					<Navigation />
				</Box>

				<Flex
					alignItems="center"
					alignContent="center"
					height="50px"
					gap={2}
					display={{ base: 'flex', mdDown: 'none' }}
				>
					<Heading
						size="lg"
						lineHeight={1}
					>
						{props.setup.symbol}
					</Heading>

					<Show when={props.setup.title}>
						-
						<Heading
							size="sm"
							lineHeight={1}
							textTransform="capitalize"
						>
							{props.setup.title}
						</Heading>
					</Show>
				</Flex>
			</Flex>

			<Flex
				alignItems="center"
				gap={2}
			>
				<Actions />
				<Menu />
			</Flex>
		</Flex>
	)
}

export default Header
